import React from "react"
import numeral from 'numeral'
import {format} from "date-fns"
import DateHelper from '../../DateHelper/DateHelper'

// import numeral from "numeral"

class ProductPresenterGeneral extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
      dateFormat: DateHelper.rubyToDateFNS(this.props.date_format),
      timeFormat: DateHelper.rubyToDateJS(this.props.time_format),
    }

  };

  render() {
    return (
      <div>
        <div className="row">
          {this.renderProductCode()}
          {this.renderProductName()}
          {this.renderProductStatus()}
          {this.renderProductDescription()}
        </div>
        <div className="row">
          {this.renderProductStartDate()}
          {this.renderProductEndDate()}
          {this.renderProductMinimumLead()}
          {this.renderProductMaximumLead()}
        </div>
        <br/>
        <div className="row bottom-spacer">
          {this.renderProductChargePanel()}
          {this.renderProductServicePanel()}
        </div>
          <div className="row">
            <div className="col-md-6">
              <div className="panel default-panel">
                <div className="panel-body">
                  <h5 className="default-panel-heading-text" style={{borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10}}>{I18n.t('booking_details')}</h5>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>{I18n.t('show_as_booking_add_on')} <span className="ss-help help" title={I18n.t('show_as_booking_add_on_helper_text')}></span></label>
                        <div>{I18n.t(this.props.product.show_as_booking_add_on ? 'yes' : 'no')}</div>
                      </div>
                    </div>
                    {
                      this.props.product.show_as_booking_add_on
                      ?
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>{I18n.t('quantity_allowed')} <span className="ss-help help" title={I18n.t('quantity_allowed_helper_text')}></span></label>
                          <div>{I18n.t(this.props.product.quantity_allowed ? 'yes' : 'no')}</div>
                        </div>
                      </div>
                      :
                      null
                    }
                    {
                      this.props.product.show_as_booking_add_on
                      ?
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>{I18n.t('collect_amount_at_booking')} <span className="ss-help help" title={I18n.t('collect_amount_at_booking_helper_text')}></span></label>
                          <div>{I18n.t(this.props.product.collect_amount_at_booking ? 'yes' : 'no')}</div>
                        </div>
                      </div>
                      :
                      null
                    }
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="panel default-panel">
                <div className="panel-body">
                  <h5 className="default-panel-heading-text" style={{borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10}}>{I18n.t('customer_portal')}</h5>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>{I18n.t('show_in_customer_portal')} <span className="ss-help help" title={I18n.t('show_in_customer_portal_on_helper_text')}></span></label>
                        <div>{I18n.t(this.props.product.show_in_customer_portal ? 'yes' : 'no')}</div>
                      </div>
                    </div>
                    {
                      this.props.product.show_in_customer_portal
                      ?
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>{I18n.t('quantity_allowed')} <span className="ss-help help" title={I18n.t('quantity_allowed_helper_text')}></span></label>
                          <div>{I18n.t(this.props.product.portal_quantity_allowed ? 'yes' : 'no')}</div>
                        </div>
                      </div>
                      :
                      null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  };

  renderProductName() {
    return(
    <div className="col-md-3">
      <label>{I18n.t('name')}</label>
      <div>{this.props.product.name}</div>
    </div>
    );
  };

  renderProductStatus() {
    return (
      <div className="col-md-2">
        <label>{I18n.t('status')}</label>
        <div>{I18n.t(this.props.product.status)}</div>
      </div>
    )
  }

  renderProductCode() {
    return(
      <div className="col-md-3">
        <label>{I18n.t('code')}</label>
        <div>{this.props.product.code}</div>
      </div>
    )
  }

  renderProductDescription() {
    return(
      <div className="col-md-3">
        <label>{I18n.t('description')}</label>
        <div>{this.props.product.description}</div>
      </div>
    );
  };

  renderProductStartDate() {
    return(
      <div className="col-md-3">
        <div className="form-group">
          <label>{I18n.t('start_date')} <span className="ss-help help" title={I18n.t('rate_start_booking_date_helper_text')}></span></label>
          {
            this.props.product.start_date
              ?
            <div>{format(this.props.product.start_date, this.state.dateFormat)}</div>
              :
            null
          }
        </div>
      </div>
    )
  }

  renderProductEndDate() {
    return(
      <div className="col-md-3">
        <div className="form-group">
          <label>{I18n.t('end_date')} <span className="ss-help help" title={I18n.t('rate_start_booking_date_helper_text')}></span></label>
          {
            this.props.product.end_date
              ?
            <div>{format(this.props.product.end_date, this.state.dateFormat)}</div>
              :
            null
          }
        </div>
      </div>
    )

  }

  renderProductMinimumLead() {
    return(
      <div className="col-sm-3">
        <div className="form-group">
          <label>{I18n.t('min_lead')} <span className="ss-help help" title={I18n.t('rate_max_lead_helper_text')}></span></label>
          <div>{this.props.product.minimum_lead}</div>
        </div>
      </div>
    )
  }

  renderProductMaximumLead() {
    return(
      <div className="col-sm-3">
        <div className="form-group">
          <label>{I18n.t('max_lead')} <span className="ss-help help" title={I18n.t('rate_max_lead_helper_text')}></span></label>
          <div>{this.props.product.maximum_lead}</div>
        </div>
      </div>
    )
  }

  renderProductServicePanel() {
    if(!this.props.product.requires_service_request) {
      return(
        <div className="col-md-6">
          <div className="panel default-panel">
            <div className="panel-body">
              <h5 className="default-panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('service')} </h5>
              <label>{I18n.t('does_this_product_require_service_request')}</label>
              <br style={{ lineHeight: '30px' }} />
              <div className="read-only-text">{I18n.t('no')}</div>
            </div>
          </div>
        </div>
      );
    } else if (this.props.product.requires_service_request) {
      return (
        <div className="col-md-6">
          <div className="panel default-panel">
            <div className="panel-body">
              <h5 className="default-panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('service')} </h5>
              <label>{I18n.t('does_this_product_require_service_request')}</label>
              <br style={{ lineHeight: '30px' }} />
              <div className="read-only-text">{I18n.t('yes')}</div>
              <div className="card service-required-well">
                <div className="row">
                  <div className="col-md-12">
                    <label>{I18n.t('assigned_to')} <span className="ss-help help" title={I18n.t('default_user_helper_text')}></span></label>
                    <div>{this.props.product.default_assigned_to ? this.props.product.default_assigned_to.first_name + " " + this.props.product.default_assigned_to.last_name : <em>{I18n.t('none')}</em>}</div>
                  </div>
                </div>
                <br/>
                <div className="row">
                  <div className="col-md-12">
                    <label>{I18n.t('service_request_description')}</label>
                    <div>{this.props.product.special_instructions}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };
  };

  renderProductChargePanel() {
    if(!this.props.product.amount) {
      return(
        <div className="col-md-6">
          <div className="panel default-panel">
            <div className="panel-body">
              <h5 className="default-panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('charge')} </h5>
              <label>{I18n.t('does_this_product_have_a_charge')} <span className="ss-help help" title={I18n.t('product_charge_helper_text')}></span></label>
              <br style={{ lineHeight: '30px' }} />
              <div className="read-only-text">{I18n.t('no')}</div>
            </div>
          </div>
        </div>
      );
    } else if(this.props.product.amount && this.props.product.amount >= 0) {
      return(
          <div className="col-md-6">
            <div className="panel default-panel">
              <div className="panel-body">
                <h5 className="default-panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('charge')} </h5>
                <label>{I18n.t('does_this_product_have_a_charge')} <span className="ss-help help" title={I18n.t('product_charge_helper_text')}></span></label>
                <br style={{ lineHeight: '30px' }} />
                <div className="read-only-text">{I18n.t('yes')}</div>
                <div className="card">
                  <div className="row">
                    <div className="col-sm-12">
                      <label>{I18n.t('amount')}</label>
                      <div>{this.formatCurrency(this.props.product.amount)}</div>
                    </div>
                  </div>
                  <br/>
                  <br/>
                  {this.renderTaxesAndGratuity()}
                </div>
              </div>
            </div>
          </div>
      );
    };
  };

  renderTaxesAndGratuity(){
    let taxes = this.props.product.taxes.map(tax => <div key={tax.id}>• {tax.name}</div>)
    return(
      <div className="row">
        <div className="col-sm-6">
          <label>{I18n.t('taxes')}</label>
          {taxes}
        </div>
      </div>
    )
  }

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  }

};

export default ProductPresenterGeneral
